import { c as _c } from "react/compiler-runtime";
import ArrowLeftIcon from '@precis-digital/kurama/icons/ArrowLeftIcon';
import Button from '@precis-digital/kurama/Button';
import CommentIcon from '@precis-digital/kurama/icons/CommentIcon';
import Divider from '@precis-digital/kurama/Divider';
import Grid from '@precis-digital/kurama/Grid';
import Typography from '@precis-digital/kurama/Typography';
import { styled } from '@precis-digital/kurama/utils';
import dashboardWithNewTag from 'public/assets/images/dashboard_w_new_tag.png';
import { type ReactElement } from 'react';
import Head from 'next/head';
import ThemedImage from 'shared/components/Themed/Image';
import { type ClientFeatureType } from 'shared/api/clients';
import { useAuth } from 'shared/context/AuthContext';
import { useCurrentClient } from 'shared/context/ClientContext';
import { useTranslation } from 'shared/translations';
import { useGoBack } from 'shared/components/Router';
import { openIntercomNewMessage } from 'shared/intercom';
import { formatPageMetaTitle } from '../../utils/stringFormatter';
import { StyledGridPageContainer, StyledGridTopSectionContainer, StyledGridRightSideContainer, StyledGridTextContainer, StyledGridErrorCodeMessageContainer } from './styles';
const NoAccessToFeature = t0 => {
  const $ = _c(72);
  const {
    featureId
  } = t0;
  const {
    currentClient
  } = useCurrentClient();
  const {
    currentUser
  } = useAuth();
  const {
    t
  } = useTranslation("common");
  const goBack = useGoBack();
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let handleContactUsClick;
  let handleTakeMeBackClick;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== currentClient.id || $[1] !== currentClient.name || $[2] !== currentUser?.name || $[3] !== featureId || $[4] !== goBack || $[5] !== t) {
    const featureName = t(`sideNavigation.${featureId}`);
    let t8;
    if ($[20] !== goBack) {
      t8 = () => {
        goBack();
      };
      $[20] = goBack;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    handleTakeMeBackClick = t8;
    handleContactUsClick = () => {
      openIntercomNewMessage(t("noAccessToFeature.contactUsEmail.body", {
        moduleName: featureName,
        workspaceName: currentClient.name,
        workspaceId: currentClient.id,
        userName: currentUser?.name ?? ""
      }))();
    };
    t7 = <Head><title>{formatPageMetaTitle({
          pageTitle: featureName
        })}</title></Head>;
    T4 = StyledGridPageContainer;
    t6 = true;
    T3 = StyledGridTopSectionContainer;
    t4 = true;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <StyledGridImageContainer><ThemedImage style={{
          width: "100%",
          height: "100%"
        }} src={dashboardWithNewTag} alt="Dashboard with 'NEW' tag" /></StyledGridImageContainer>;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    T2 = StyledGridRightSideContainer;
    T1 = StyledGridTextContainer;
    let t9;
    if ($[23] !== t) {
      t9 = t("noAccessToFeature.header.fragment1");
      $[23] = t;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    let t10;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <br />;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    t3 = <Typography variant="h2">{t9}{t10}{t("noAccessToFeature.header.fragment2", {
        moduleName: featureName
      })}</Typography>;
    T0 = Typography;
    t1 = "body2";
    t2 = t("noAccessToFeature.description", {
      moduleName: featureName,
      workspaceName: currentClient.name
    });
    $[0] = currentClient.id;
    $[1] = currentClient.name;
    $[2] = currentUser?.name;
    $[3] = featureId;
    $[4] = goBack;
    $[5] = t;
    $[6] = T0;
    $[7] = T1;
    $[8] = T2;
    $[9] = T3;
    $[10] = T4;
    $[11] = handleContactUsClick;
    $[12] = handleTakeMeBackClick;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    T0 = $[6];
    T1 = $[7];
    T2 = $[8];
    T3 = $[9];
    T4 = $[10];
    handleContactUsClick = $[11];
    handleTakeMeBackClick = $[12];
    t1 = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
  }
  let t8;
  if ($[26] !== T0 || $[27] !== t1 || $[28] !== t2) {
    t8 = <T0 variant={t1}>{t2}</T0>;
    $[26] = T0;
    $[27] = t1;
    $[28] = t2;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== T1 || $[31] !== t3 || $[32] !== t8) {
    t9 = <T1>{t3}{t8}</T1>;
    $[30] = T1;
    $[31] = t3;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ArrowLeftIcon />;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== t) {
    t11 = t("noAccessToFeature.takeMeBack");
    $[35] = t;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== handleTakeMeBackClick || $[38] !== t11) {
    t12 = <Button leftIcon={t10} variant="filled" onClick={handleTakeMeBackClick}>{t11}</Button>;
    $[37] = handleTakeMeBackClick;
    $[38] = t11;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <CommentIcon />;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t) {
    t14 = t("noAccessToFeature.contactUs");
    $[41] = t;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== handleContactUsClick || $[44] !== t14) {
    t15 = <Button leftIcon={t13} variant="tonal" onClick={handleContactUsClick}>{t14}</Button>;
    $[43] = handleContactUsClick;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t12 || $[47] !== t15) {
    t16 = <Grid alignSelf="center" gap="8px" display="flex">{t12}{t15}</Grid>;
    $[46] = t12;
    $[47] = t15;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== T2 || $[50] !== t16 || $[51] !== t9) {
    t17 = <T2>{t9}{t16}</T2>;
    $[49] = T2;
    $[50] = t16;
    $[51] = t9;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== T3 || $[54] !== t17 || $[55] !== t4 || $[56] !== t5) {
    t18 = <T3 hasDashboardFrame={t4}>{t5}{t17}</T3>;
    $[53] = T3;
    $[54] = t17;
    $[55] = t4;
    $[56] = t5;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Divider />;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Typography variant="h4">403</Typography>;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== t) {
    t21 = t("noAccessToFeature.errorDescription");
    $[60] = t;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  let t22;
  if ($[62] !== t21) {
    t22 = <StyledGridErrorCodeMessageContainer>{t20}<Typography variant="body2">{t21}</Typography></StyledGridErrorCodeMessageContainer>;
    $[62] = t21;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== T4 || $[65] !== t18 || $[66] !== t22 || $[67] !== t6) {
    t23 = <T4 hasDashboardFrame={t6}>{t18}{t19}{t22}</T4>;
    $[64] = T4;
    $[65] = t18;
    $[66] = t22;
    $[67] = t6;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  let t24;
  if ($[69] !== t23 || $[70] !== t7) {
    t24 = <>{t7}{t23}</>;
    $[69] = t23;
    $[70] = t7;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  return t24;
};
const StyledGridImageContainer = styled(Grid)(() => ({
  width: '40%',
  transform: 'scale(1.4)'
}));
export default NoAccessToFeature;